import { permissionsRol as usersBackOfficeRol } from 'app/policies/roles/usersBackOfficeRol.access';
import { permissionsRol as usersRol } from 'app/policies/roles/usersRol.access';
import { PATH_USER, PATH_USERS, PATH_USER_ADMIN, PATH_USER_CREATE, PATH_USER_CREATE_ADMIN } from 'app/router/routesConfigUser';

export function users(path, user) {
  if (PATH_USER === path) {
    return usersRol(user).readDetail;
  }

  if (PATH_USERS === path) {
    return usersRol(user).readList;
  }

  if (PATH_USER_CREATE === path) {
    return usersRol(user).create;
  }

  if (PATH_USER_ADMIN === path) {
    return usersBackOfficeRol(user).readList;
  }

  if (PATH_USER_CREATE_ADMIN === path) {
    return usersBackOfficeRol(user).create;
  }

  return true;
}
